import * as React from 'react'
import { Link } from "react-router-dom"
import { AppBar, Box, Toolbar, IconButton, MenuItem, Container, Button, Tooltip, MenuList, Popover } from '@mui/material'
import { Menu as MenuIcon, AccountCircle as AccountCircleIcon } from '@mui/icons-material'
import { AuthContext } from 'contexts/authContext'
import { DeliveryDateContext } from 'contexts/deliveryDateContext'

/**
 * Header component for displaying logo and the navigation
 */
const Header = () => {
  const [navAnchorEl, setAnchorElNav] = React.useState(null)
  const [userAnchorEl, setAnchorElUser] = React.useState(null)
  const { dispatch } = React.useContext(AuthContext)
  const { deliveryDate } = React.useContext(DeliveryDateContext)

  // Navigation menu array
  const navMenu = [
    ['Overview', '/overview/' + deliveryDate],
    ['Price Sheet', '/price-sheet/' + deliveryDate],
    ['Summary', '/summary/' + deliveryDate],
    ['Schedules', '/schedules'],
    ['New Order', '/orders/create'],
  ]

  // Handling nav menu
  const openNavMenu = (event) => {
    setAnchorElNav(event.currentTarget)
  }
  const closeNavMenu = () => {
    setAnchorElNav(null)
  }

  // Handling user menu
  const openUserMenu = (event) => {
    setAnchorElUser(event.currentTarget)
  }
  const closeUserMenu = () => {
    setAnchorElUser(null)
  }

  // User logout
  const logout = () => {
    dispatch({ type: 'LOGOUT' })
  }

  return (
    <AppBar position="static" sx={{ bgcolor: 'white', py: 3, boxShadow: 'none', borderBottom: '1px solid', borderColor: 'divider', displayPrint: 'none' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* Mobile menu */}
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="small"
              aria-label="Navigation"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={openNavMenu}
              color="primary"
            >
              <MenuIcon />
            </IconButton>
            <Popover
              id="menu-appbar"
              anchorEl={navAnchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(navAnchorEl)}
              onClose={closeNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
              keepMounted
            >
              <MenuList>
                {navMenu.map((navItem) => (
                  <MenuItem key={navItem[0]} component={Link} to={navItem[1]} onClick={closeNavMenu}>
                    {navItem[0]}
                  </MenuItem>
                ))}
              </MenuList>
            </Popover>
          </Box>

          {/* Logo */}
          <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: { xs: 1, md: 0 } }}>
            <Box
              component="img"
              src="/images/freshmtl-logo.svg"
              alt="FreshMTL"
              sx={{
                width: 70,
                height: 70,
              }}
            />
          </Box>

          {/* Desktop menu */}
          <Box sx={{ flexGrow: 1, ml: 4, display: { xs: 'none', md: 'flex' } }}>
            {navMenu.map((navItem) => (
              <Button
                key={navItem[0]}
                component={Link}
                to={navItem[1]}
                onClick={closeNavMenu}
                size="large"
                sx={{
                  mx: 1,
                  my: 2,
                  display: 'block',
                  fontSize: '1rem',
                  fontWeight: 'fontWeightMedium',
                  color: 'text.primary',
                  textTransform: 'capitalize',
                  '&:hover': {
                    backgroundColor: 'white',
                    textDecoration: 'underline',
                    color: 'primary.main',
                  },
                }}
              >
                {navItem[0]}
              </Button>
            ))}
          </Box>
          
          {/* User menu */}
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="User menu">
              <IconButton size="large" color="primary" onClick={openUserMenu} sx={{ p: 0 }}>
                <AccountCircleIcon />
              </IconButton>
            </Tooltip>

            <Popover
              id="menu-appbar"
              anchorEl={userAnchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(userAnchorEl)}
              onClose={closeUserMenu}
              sx={{ mt: '45px' }}
              keepMounted
            >
              <MenuList component="div">
                <MenuItem component={Link} to="/account" onClick={closeUserMenu}>
                  My Account
                </MenuItem>
                <MenuItem component="div" onClick={logout}>
                  Logout
                </MenuItem>
              </MenuList>
            </Popover>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default Header
